import {
  GENERATE_GLOBAL_NORMS,
  GLOBAL_NORMS_LIST,
  GROUP_NORMS_LIST,
  GROUP_NORMS_DETAILS_LIST,

  NORMS_SUCCESS,
  NORMS_ERROR,
} from "./actionTypes"

// Generate Global Norms
export const generateGlobalNorms = (data, history, callback) => {
  return {
    type: GENERATE_GLOBAL_NORMS,
    payload: { data, history, callback }
  }
}

// Global Norms
export const listGlobalNorms = (data, callback) => {
  return {
    type: GLOBAL_NORMS_LIST,
    payload: { data, callback },
  }
}

// Global Norms List
export const listGroupNorms = (data, callback) => {
  return {
    type: GROUP_NORMS_LIST,
    payload: { data, callback },
  }
}

// Global Norms Details
export const listGroupNormsDetails = (data, callback) => {
  return {
    type: GROUP_NORMS_DETAILS_LIST,
    payload: { data, callback },
  }
}

export const normsSuccess = message => {
  return {
    type: NORMS_SUCCESS,
    payload: message,
  }
}

export const normsError = message => {
  return {
    type: NORMS_ERROR,
    payload: message,
  }
}
